import { Link, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';

/**
 * Shows the bottom Copyright Bar.
 */
const Copyright = () => (
  <>
    <Typography variant="body2" color="textSecondary">
      Copyright ©{' '}
      <Link
        underline="hover"
        color="inherit"
        target="_blank"
        rel="noreferrer noopener"
        href="https://pella.com/"
      >
        Pella
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
    {process.env.REACT_APP_BUILD_VERSION && (
      <>
        <Divider
          orientation="vertical"
          style={{
            height: '100%',
            width: '1px',
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            margin: '0 8px',
          }}
        />
        <Typography variant="body2" color="textSecondary">
          Version - {process.env.REACT_APP_BUILD_VERSION}
        </Typography>
      </>
    )}
  </>
);

export default Copyright;
